<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      :ordenar-por="['nome']"
      :ordenar-nomes="['Nome']"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
            <CampoNome :valor="filtro.nome" @atualizar="filtro.nome = $event" />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><EspecialidadeTabela :especialidades="especialidades"
      /></template>
      <template #fichas>
        <div
          v-for="especialidade in especialidades"
          :key="especialidade._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <EspecialidadeFicha :especialidade="especialidade" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import numeral from 'numeral'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'

import EspecialidadeFicha from './EspecialidadeFicha'
import EspecialidadeTabela from './EspecialidadeTabela'

export default {
  name: 'Especialidades',
  components: {
    EspecialidadeFicha,
    EspecialidadeTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const convenios = ref([])
    const especialidades = ref([])
    const servico = new EspecialidadeServico()
    const nomeResultado = 'especialidades'
    const nomeDoForm = 'EspecialidadeForm'
    const filtro = ref({
      nome: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: especialidades,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      posPesquisar: () => {
        for (const especialidade of especialidades.value) {
          for (const convenio of especialidade.convenios) {
            const valorFormatado = numeral(convenio.valor).format('0,0.00')
            if (convenio.tipoValor === 1) {
              convenio._valor = `R$ ${valorFormatado}`
            } else if (convenio.tipoValor === 2) {
              convenio._valor = `${valorFormatado} %`
            }
          }
        }
      },
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(37)
    return {
      convenios,
      especialidades,
      servico,
      filtro,
      ...pesquisa,
    }
  },

  methods: {
    posPesquisar() {
      for (const especialidade of this.especialidades) {
        for (const convenio of especialidade.convenios) {
          const valorFormatado = numeral(convenio.valor).format('0,0.00')
          if (convenio.tipoValor === 1) {
            convenio._valor = `R$ ${valorFormatado}`
          } else if (convenio.tipoValor === 2) {
            convenio._valor = `${valorFormatado} %`
          }
        }
      }
    },
  },
}
</script>
